module.exports = __webpack_public_path__ + "static/media/header.90472078.jpg";